import React, { useEffect, useState } from 'react';
import { Camera, ExternalLink } from 'lucide-react';
import API_URL from '../../config';
import SEO from './SEO';

export default function PageGaleria() {
    const [galleries, setGalleries] = useState([]);

    useEffect(() => {
        fetch(`${API_URL}/gallery-years`)
            .then(r => r.json())
            .then(data => setGalleries(data.sort((a, b) => b.year - a.year)))
            .catch(() => {});
    }, []);

    const displayGalleries = galleries.length > 0 ? galleries : [];

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20">
            <SEO 
                title="Fotogaléria | Malodunajský vodácky maratón"
                description="Pozrite si najlepšie momenty z maratónu. Fotky z trate, štartu aj cieľa nášho splavu."
                keywords="fotky splav, galéria maratón, vodácke fotky, Malý Dunaj foto"
            />
            <h2 className="text-3xl md:text-5xl font-black uppercase tracking-widest flex items-center gap-4 mb-8" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                <Camera className="w-10 h-10 md:w-12 md:h-12 text-yellow-400" />
                <span className="text-white drop-shadow-md">Galéria Maratónu</span>
            </h2>
            <p className="text-white/80 font-medium text-lg mb-12 max-w-2xl">
                Prezrite si momenty plné potu, radosti a vody. Všetky kompletné galérie z jednotlivých ročníkov nájdete v našich Google Photos albumoch.
            </p>

            {displayGalleries.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {displayGalleries.map(gallery => (
                        <div key={gallery.id} className="bg-white rounded-2xl overflow-hidden shadow-xl group flex flex-col">
                            <div className="relative h-56 overflow-hidden bg-gray-200">
                                <div className="absolute inset-0 bg-blue-900/10 group-hover:bg-transparent transition-colors z-10"></div>
                                <img
                                    src={gallery.cover_image_url || `https://placehold.co/600x400/1e3a8a/ffffff?text=FOTO+${gallery.year}`}
                                    alt={gallery.title}
                                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                                />
                                <div className="absolute top-4 right-4 bg-yellow-400 text-blue-900 font-black px-4 py-1.5 rounded-lg z-20 shadow-md" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                                    {gallery.year}
                                </div>
                            </div>
                            <div className="p-6 flex-grow flex flex-col justify-between bg-white">
                                <div>
                                    <h3 className="text-blue-900 font-black text-xl uppercase tracking-widest mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>{gallery.title}</h3>
                                    <p className="text-gray-500 font-medium text-sm mb-6">Oficiálne fotografie z trate, štartu aj vyhlasovania výsledkov.</p>
                                </div>
                                {gallery.google_photos_url && gallery.google_photos_url !== '#' ? (
                                    <a href={gallery.google_photos_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-cyan-600 font-bold uppercase hover:text-cyan-700 transition-colors">
                                        Otvoriť Google Photos <ExternalLink className="w-4 h-4" />
                                    </a>
                                ) : (
                                    <span className="text-gray-400 font-bold text-sm">Odkaz čoskoro</span>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-white/80 font-medium text-center py-10">Nepodarilo sa načítať galérie.</div>
            )}
        </div>
    );
}
